// Utility to handle API calls (Resend, etc.)
// Since we don't have a backend server, we'll simulate the API calls
// In a real production app, these would call your backend endpoints /api/send-otp etc.

export const sendOTP = async (email: string): Promise<boolean> => {
  console.log(`Sending OTP to ${email}...`)
  // Simulate network delay
  await new Promise((resolve) => setTimeout(resolve, 1500))
  return true
}

export const verifyOTP = async (
  email: string,
  otp: string,
): Promise<boolean> => {
  console.log(`Verifying OTP ${otp} for ${email}...`)
  await new Promise((resolve) => setTimeout(resolve, 1500))
  // For demo, accept any 6 digit code
  return otp.length === 6 && /^\d+$/.test(otp)
}

export const sendOrderConfirmation = async (
  email: string,
  orderDetails: any,
): Promise<boolean> => {
  console.log(`Sending confirmation to ${email}...`, orderDetails)
  await new Promise((resolve) => setTimeout(resolve, 1000))
  return true
}

export const sendShopNotification = async (
  orderDetails: any,
): Promise<boolean> => {
  console.log(`Sending shop notification...`, orderDetails)
  await new Promise((resolve) => setTimeout(resolve, 1000))
  return true
}
